import React from "react";
import { Checkbox, FormControlLabel, FormGroup, Typography, Stack, Tooltip, IconButton, FormControl, FormHelperText } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

const ReusableCheckboxGroup = ({ title, options, selectedOptions, setSelectedOptions, optionLabel, selectAllLabel, helperText, error, requireValue }) => {
    // Find "All Users" (or select all) option dynamically
    const allOption = selectAllLabel ? options.find(option => option[optionLabel] === selectAllLabel) : null;
    const otherOptions = selectAllLabel ? options.filter(option => option[optionLabel] !== selectAllLabel) : options;

    // Check if all individual checkboxes (excluding "All Users") are selected
    //  const areAllOtherChecked = otherOptions.every(option => selectedOptions.some(item => item.id === option.id));
    const errorStyle = { color: error ? '#d32f2f' : '#4C4E64' }

    const handleChange = (event, option) => {
        const { checked } = event.target;
        const optionId = option.id || option.value;

        if (selectAllLabel && option[optionLabel] === selectAllLabel) {
            // If "All Users" is checked, select all options
            setSelectedOptions(checked ? options : []);
        } else {
            // Add or remove selected option
            // let newSelectedOptions = checked
            //     ? [...selectedOptions, option]
            //     : selectedOptions.filter(item => item.id !== option.id);

            let newSelectedOptions;

            if (checked) {
                newSelectedOptions = [...selectedOptions, option];
            } else {
                newSelectedOptions = selectedOptions.filter(
                    item => (item.id || item.value) !== optionId
                );
            }

            // If all other checkboxes are selected, check "All Users"
            if (allOption && otherOptions.every(opt => newSelectedOptions.some(item => item.id === opt.id))) {
                newSelectedOptions = [...newSelectedOptions, allOption];
            } else {
                // If any option is unchecked, remove "All Users"
                newSelectedOptions = newSelectedOptions.filter(item => item[optionLabel] !== selectAllLabel);
            }

            setSelectedOptions(newSelectedOptions);
        }
    };

    return (
        <Stack spacing={1} mb={2} >
            <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: '14px', ...errorStyle }}>
                {title}
                {requireValue ? <span style={{ color: '#d32f2f' }}> *</span> : null}
            </Typography>
            <FormControl error={error}>
                <FormGroup row>
                    {options.map((option) => (
                        <>
                            <FormControlLabel
                                key={option.id}
                                control={
                                    <Checkbox
                                        // checked={selectedOptions.some((item) => item.id === option.id)}
                                        checked={selectedOptions.some((item) => (item.id || item.value) === (option.id || option.value))}
                                        onChange={(e) => handleChange(e, option)}
                                        name={option[optionLabel]}
                                        // color="primary"
                                        sx={errorStyle}
                                    />
                                }
                                label={option[optionLabel]}
                                sx={errorStyle}
                            />
                            {option?.helperText && <Tooltip title={option?.helperText} arrow>
                                <IconButton>
                                    <InfoIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>}
                        </>
                    ))}
                </FormGroup>
                <FormHelperText>{helperText}</FormHelperText>
            </FormControl>
        </Stack>
    );
};

export default ReusableCheckboxGroup;
